import {
	Button,
	Typography,
	Dialog,
	DialogContent,
	DialogTitle,
	DialogActions,
	Stack,
	Box,
	Link,
} from '@mui/material';
import { colours } from '../../shared/colors';
import { Link as RouterLink } from 'react-router-dom';
// import '../../shared/scss/components/modal.scss';

/**
 * Component for the "Get Support" modal.
 *
 * This component displays a modal with support information, including how to access the Delta Broker Portal
 * and instructions for users who have forgotten their password.
 *
 * @param {Object} props - The props passed to the component.
 * @param {boolean} props.open - A boolean indicating whether the modal is open.
 * @param {Function} props.handleClose - A function to handle closing the modal.
 * @returns {JSX.Element} The rendered "Get Support" modal UI.
 */
const GetSupport = ({ open, handleClose }: any) => {
	return (
		<Dialog
			open={open}
			onClose={handleClose}
			sx={{ '& .MuiPaper-root': { borderRadius: '15px' } }}
		>
			<DialogTitle>
				<Stack direction='row' justifyContent={'space-between'}>
					{'Help Centre'}
					<Button variant='text' size='small' onClick={handleClose}>
						Close
					</Button>
				</Stack>
			</DialogTitle>
			<DialogContent>
				<Stack spacing={4}>
					<Stack spacing={2}>
						<Typography variant='cardContentHeader'>
							How do I access the Delta Broker Portal?
						</Typography>
						<Typography variant='subtitle1'>
							To use this site, you will need to be a registered user. To request
							registration, or for assistance with a forgotten user name or password,
							please contact Delta by email at
							<Link
								href='mailto:contactus@deltainsurance.com.au'
								sx={{
									mx: '0.5em',
									color: colours.darkGrey.main,
									textDecorationColor: colours.darkGrey.main,
								}}
							>
								contactus@deltainsurance.com.au
							</Link>
							or by phone on <u> (07) 3017 4720. </u>
						</Typography>
					</Stack>
					<Stack spacing={2}>
						<Typography variant='cardContentHeader'>
							I have forgotten my password
						</Typography>

						<Typography variant='subtitle1'>
							Please request a password reset at
							<Link
								to={`/ResetPassword`}
								component={RouterLink}
								variant='subtitle1'
								sx={{
									textDecorationColor: colours.darkGrey.main,
									color: colours.darkGrey.main,
                                    pl: '0.5em'
								}}
							>
								Forgot Password?
							</Link>
							{/* <Link
								href="mailto:contactus@deltainsurance.com.au"
								sx={{
									mx: "0.5em",
									color: colours.darkGrey.main,
									textDecorationColor: colours.darkGrey.main,
								}}
							>
								contactus@deltainsurance.com.au
							</Link>
							or by phone on <u> (07) 3017 4720. </u> */}
						</Typography>
					</Stack>
				</Stack>
				<Box pb='0.5em'></Box>
			</DialogContent>
		</Dialog>
	);
};

export default GetSupport;
